import { useEffect, useState } from 'react'

import {
  getColor,
  getHealthFactor,
  getUserPosition,
  healthFactorGradient
} from '../utils/getUserPosition'

import { useShowUserBalances } from './useShowUserBalances'

function usePositionHealth({ debtInUsd, issuableLimitInUsd, options }) {
  const [rawHealthFactor, setRawHealthFactor] = useState()
  const [percent, setPercent] = useState(0)
  const showUserBalances = useShowUserBalances()

  const userPosition = getUserPosition({
    debtInUsd,
    issuableLimitInUsd,
    options
  })

  useEffect(
    function () {
      if (!debtInUsd || !showUserBalances) {
        setPercent(0)
        setRawHealthFactor(undefined)
      } else if (debtInUsd && issuableLimitInUsd) {
        setPercent(userPosition.percent)
        setRawHealthFactor(userPosition.rawHealthFactor)
      }
    },
    [
      userPosition.percent,
      userPosition.rawHealthFactor,
      debtInUsd,
      issuableLimitInUsd,
      showUserBalances
    ]
  )

  return {
    ...userPosition,
    getColor,
    healthFactor: getHealthFactor(rawHealthFactor),
    healthFactorGradient,
    percent,
    rawHealthFactor
  }
}

export default usePositionHealth
